
import { Layers, X } from "lucide-react";

interface CreateBatchModalProps {
  isOpen: boolean;
  newTitle: string;
  newDescription: string;
  creatingBatch: boolean;
  onClose: () => void;
  onTitleChange: (val: string) => void;
  onDescriptionChange: (val: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export function CreateBatchModal({
  isOpen,
  newTitle,
  newDescription,
  creatingBatch,
  onClose,
  onTitleChange,
  onDescriptionChange,
  onSubmit,
}: CreateBatchModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-stone-900/50 dark:bg-black/70 backdrop-blur-xs p-4">
      <div className="bg-white dark:bg-stone-900 rounded-2xl border border-stone-200 dark:border-stone-800 shadow-xl max-w-md w-full overflow-hidden p-5 space-y-4">
        <div className="flex items-center justify-between border-b border-stone-100 dark:border-stone-800 pb-3">
          <div className="flex items-center gap-2">
            <Layers className="w-4 h-4 text-emerald-600 dark:text-emerald-400" />
            <h3 className="text-sm font-bold text-stone-900 dark:text-stone-100">Create Feedback Batch</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-stone-400 hover:text-stone-600 p-1"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <form onSubmit={onSubmit} className="space-y-3 text-xs">
          <div>
            <label className="block font-semibold text-stone-700 dark:text-stone-300 mb-1">
              Batch Title
            </label>
            <input
              type="text"
              placeholder="e.g., Don Silvestre Minimum Stay Rule Improvements"
              value={newTitle}
              onChange={(e) => onTitleChange(e.target.value)}
              className="w-full rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900 p-2 text-xs text-stone-900 dark:text-stone-100 focus:outline-hidden"
              autoFocus
            />
          </div>

          <div>
            <label className="block font-semibold text-stone-700 dark:text-stone-300 mb-1">
              Description (Optional)
            </label>
            <textarea
              rows={3}
              placeholder="Objectives, affected agents, or issues reported by operators..."
              value={newDescription}
              onChange={(e) => onDescriptionChange(e.target.value)}
              className="w-full rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900 p-2 text-xs text-stone-900 dark:text-stone-100 focus:outline-hidden"
            />
          </div>

          <div className="flex justify-end gap-2 pt-2 border-t border-stone-100 dark:border-stone-800">
            <button
              type="button"
              onClick={onClose}
              className="px-3 py-1.5 rounded-lg border border-stone-200 dark:border-stone-800 text-stone-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={creatingBatch || !newTitle.trim()}
              className="px-4 py-1.5 rounded-lg bg-stone-900 dark:bg-stone-100 text-white dark:text-stone-900 font-bold transition disabled:opacity-50"
            >
              {creatingBatch ? "Creating..." : "Create Batch"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
